export const STUDY_FILTER_VIEWS = ['All', 'UAT testing', 'Live', 'Draft', 'On hold', 'Close out', 'Cancelled']
